const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reduceMotion) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.p2c-reveal, .p2c-split__media').forEach((element) => revealObserver.observe(element));
}

const setHeaderState = () => {
  if (!document.body.classList.contains('template-index')) return;
  document.body.classList.toggle('p2c-header-solid', window.scrollY > 20);
};
setHeaderState();
window.addEventListener('scroll', setHeaderState, { passive: true });

if (!reduceMotion) {
  const updateScrollScale = () => {
    const y = Math.min(window.scrollY, window.innerHeight);
    document.documentElement.style.setProperty('--p2c-hero-scale', String(1 + y / 7000));
    document.documentElement.style.setProperty('--p2c-banner-scale', String(1 + y / 10000));
  };
  updateScrollScale();
  window.addEventListener('scroll', updateScrollScale, { passive: true });
}

document.querySelectorAll('[data-p2c-slider]').forEach((slider) => {
  const slides = Array.from(slider.querySelectorAll('[data-p2c-slide]'));
  const previous = slider.querySelector('[data-p2c-prev]');
  const next = slider.querySelector('[data-p2c-next]');
  const pause = slider.querySelector('[data-p2c-pause]');
  let active = 0;
  let paused = false;

  const show = (index) => {
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === active;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });
  };

  previous?.addEventListener('click', () => show(active - 1));
  next?.addEventListener('click', () => show(active + 1));
  pause?.addEventListener('click', () => {
    paused = !paused;
    pause.setAttribute('aria-pressed', String(paused));
    pause.textContent = paused ? 'Play' : 'Pause';
  });

  if (slides.length > 1 && !reduceMotion) {
    window.setInterval(() => {
      if (!paused && !slider.matches(':hover')) show(active + 1);
    }, 5500);
  }
});
